const getters = {
  // 添加这个getter方法
  findMenuByPath: (state) => (path) => {
    function find(menus) {
      for (const menu of menus) {
        if (menu.path === path) return menu
        if (menu.children) {
          const found = find(menu.children)
          if (found) return found
        }
      }
      return null
    }
    return find(state.menus)
  },
  topMenus: state => {
    const menus = state.user?.menus.menus || []
    //console.log('menus数据结构:', JSON.parse(JSON.stringify(menus))) // 深拷贝避免响应式对象影响
    return menus.filter(menu => {
      //console.log('当前menu对象:', menu)
      return !menu?.parentUid
    })
  },
  
  sideMenus: state => {
    // 添加空值检查和默认值
    const menus = state.user?.menus.menus || []
    const activeTopMenu = state.app?.activeTopMenu
    
    if (!activeTopMenu) return []
    
    const topMenu = menus.find(menu => menu?.uid === activeTopMenu)
    // 确保 children 存在且是数组
    return topMenu?.children?.filter(item => item) || []
  },
  
  // 可选：添加缓存版本（如果菜单不常变化）
  cachedTopMenus: (state, getters) => {
    return getters.topMenus
  }
}

export default getters